<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Usuario</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		 <material-card
          color="green"
          title="Listado de usuarios"
          text="Usuarios habilitados para realizar acciones dentro de la plataforma"
        >
       	 	<v-text-field
            name="search" solo
            label="Buscar" append-icon="fa fa-search"
            id="id" />
					<v-progress-linear :height="5" :active="table.loading" indeterminate></v-progress-linear>

           	<v-data-table v-model="selected"
              :headers="table.headers"
              :items="table.items"
              :search="table.search"
              class="elevation-1"
              item-key="id" show-select >
                <template v-slot:item.actions="props">
                  <td >
                    <v-btn text  color="warning" small fab  @click="activeForm('update', props.item)"><v-icon>fa fa-pen</v-icon></v-btn>
                    <v-btn text v-if="props.item.edit"  color="error" small fab @click="confirmDelete(props.item)"><v-icon>fa fa-trash</v-icon></v-btn>
                  </td>
                </template>
            </v-data-table> 
        </material-card>
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" @click="activeForm('create', {})">Agregar nuevo Usuario</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 	<v-dialog
	 	  v-model="modalDelete.active"
	 	  scrollable  
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Borrar Usuario</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	<p>¿Esta seguro de borrar este usuario?</p>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="warning" @click="modalDelete.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="error" @click="deleteItem()">Eliminar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalForm.active"
	 	  scrollable  
	 	  :overlay="false"
	 	  max-width="600px"
	 	  transition="dialog-transition"
	 	>
	 	  <v-card>
	 	    <v-card-title primary-title>
	 	      {{ modalForm.title }}
	 	    </v-card-title>
	 	    <v-card-text>
	 	    	<v-container>
		 	      <v-text-field
		 	        name="name"
		 	        label="Nombre"
		 	        id="id"
						  v-model="modalForm.data.name"
		 	      ></v-text-field>
		 	      <v-text-field
		 	        name="name"
		 	        label="Correo Electronico"
						  v-model="modalForm.data.email"
		 	        id="id"
		 	      ></v-text-field>
						<v-select
						  :items="roles"
						  item-text="text" item-value="value"
						  v-model="modalForm.data.role_id"
						  label="Permisos"
						></v-select>
	 	    	</v-container>
	 	    </v-card-text>
	 	    <v-card-actions>
	 	      <v-btn color="warning"  @click="modalForm.active = false">Cancelar</v-btn>
	 	      <v-spacer></v-spacer>
	 	      <v-btn color="success" v-if="modalForm.type == 'update'" @click="update()">Actualizar</v-btn>
	 	      <v-btn color="success" v-if="modalForm.type == 'create'" @click="store()">Guardar</v-btn>
	 	    </v-card-actions>
	 	  </v-card>
	 	</v-dialog>
	 	<v-snackbar
	 		:color="alert.color"
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.messague }}
	 	  <v-btn text  @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
	export default{
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				basePath: process.env.VUE_APP_URL + 'api',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				modalDelete: {
					active: false,
					data: {}
				},
				modalForm: {
					active: false,
					data: {},
					title: '',
					type: ''
				},	
				alert: {
					active: false,
					messague: "",
					color: "success"
				},
				selected: [],
				roles: []
			}
		},
		methods: {
			getData(){
				this.table.loading = true	
				axios.get(this.basePath + "/user").then((res) => {
					this.table.loading = false
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.messague = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
						this.selects = res.data.selects;
					}
				}).catch((error) => {
					this.table.loading = false
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			confirmDelete(item){
				this.modalDelete.active = true;
				this.modalDelete.data = item;
			},
			deleteItem(){
				axios.post(this.basePath + "/user/destroy", this.modalDelete.data).then((res) => {
					if(res.data.success != "Exito"){
						this.alert.active = true;
						this.alert.messague = "Imposible de eliminar";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Eliminado correctamente";
						this.alert.color = "error";
						this.getData();
						this.modalDelete.active = true;
						this.modalDelete.data = {};
					}	
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			activeForm(type, data = {}){
				this.modalForm.active = true;
				this.modalForm.data = data;
				this.modalForm.title = type == 'create' ? 'Crear Usuario' : 'Actualizar usuario';
				this.modalForm.type = type;
				this.setRoles();
			},
			setRoles(){
				if(this.$store.state.api.user.role_id == 1){
					this.roles = [
						{ value: 1, text: 'Administrador'},
						{ value: 2, text: 'Usuario'},
						{ value: 3, text: 'Visualizador'},
					]
				}else{
					this.roles = [
						{ value: 2, text: 'Usuario'},
						{ value: 3, text: 'Visualizador'},
					]
				}
			},
			update(){
				axios.put(this.basePath + "/user/update", this.modalForm.data ).then((res) => {
					this.alert.active = true;
					this.alert.messague = "Usuario Guardado exitosamente";
					this.alert.color = "success";
					this.closeModal()
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error inesperado en el servidor pruebe nuevamente mas tarde";
					this.alert.color = "error";
					this.closeModal()

				})
			},
			store(){
				axios.post(this.basePath + "/user/store", this.modalForm.data).then((res) => {
					this.alert.active = true;
					this.alert.messague = "Usuario Guardado exitosamente";
					this.alert.color = "success";
					this.closeModal()
				}).catch((error) => {
					this.alert.active = false;
					this.alert.messague = "Hubó un error inesperado en el servidor pruebe nuevamente mas tarde";
					this.alert.color = "error";
					this.closeModal()

				})
			},
			closeModal(){
				this.modalForm.active = false;
				this.modalForm.data = {};
				this.modalForm.type = '';
				this.getData();
			}
		},
		watch: {

		},
		computed: {
			permissEdit: function(user){
				console.log(user);
				if(this.$store.state.api.user.role_id == 1){
					if(user.id != this.$store.state.api.user.id ){
						return true;
					}else{
						return false;
					}
				}else if(this.$store.state.api.user.role_id == 2){
					if(user.role_id != 1 && user.id != this.$store.state.api.user.id){
						return true;
					}else{
						return false;
					}
				}else{
					return false;
				}
			}
		},	
	}
</script>	